import React from 'react';

/**
 * Brand Logo
 * Brand mark + wordmark shown at the top of the auth layout.
 */
function BrandLogo({ size = 40 }) {
    return (
        <div className="brand-logo">
            {/* <svg width={size} height={size} viewBox="0 0 60 60" fill="none">
                <rect width="60" height="60" rx="14" fill="url(#brand-logo-gradient)" />
                <path d="M30 15L20 25V40H25V30H35V40H40V25L30 15Z" fill="white" />
                <defs>
                    <linearGradient
                        id="brand-logo-gradient"
                        x1="0"
                        y1="0"
                        x2="60"
                        y2="60"
                    >
                        <stop offset="0%" stopColor="#CB001C" />
                        <stop offset="100%" stopColor="#A80016" />
                    </linearGradient>
                </defs>
            </svg> */}
            <img src='/media/logo.png' width={32}/>
            <span className="brand-logo__text">سامانه گواهی دیجیتال رهسا</span>
        </div>
    );
}

export default BrandLogo;
